"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsService = exports.ExperimentsService = void 0;
var tslib_1 = require("tslib");
var wix_experiments_1 = require("@wix/wix-experiments");
var ExperimentsService = /** @class */ (function () {
    function ExperimentsService() {
        this.isConducted = false;
    }
    ExperimentsService.buildInstance = function (instanceOrParams) {
        if (instanceOrParams instanceof wix_experiments_1.default) {
            return instanceOrParams;
        }
        var experimentsParams = instanceOrParams;
        var initParams = {};
        if (experimentsParams.experiments) {
            initParams.experiments = experimentsParams.experiments;
        }
        else {
            initParams = {
                baseUrl: experimentsParams.baseUrl || 'https://www.wix.com',
                scope: experimentsParams.scope || 'cashier',
                useNewApi: false,
            };
            if (experimentsParams.forSiteVisitors) {
                initParams.requestContext = initParams.requestContext || {};
                initParams.requestContext.forSiteVisitors = experimentsParams.forSiteVisitors;
            }
            else if (experimentsParams.forSiteOwner) {
                initParams.requestContext = initParams.requestContext || {};
                initParams.requestContext.forSiteOwner = experimentsParams.forSiteOwner;
            }
        }
        return new wix_experiments_1.default(initParams);
    };
    ExperimentsService.prototype.isEnabled = function (experimentName) {
        if (!this.isReady()) {
            console.error("Experiments Service :: isEnabled('" + experimentName + "') called while experiments are not conducted yet. Returning false");
            return false;
        }
        return this.experimentsInstance.enabled(experimentName);
    };
    ExperimentsService.prototype.isReady = function () {
        return this.isConducted;
    };
    ExperimentsService.prototype.init = function (instanceOrParams) {
        if (instanceOrParams === void 0) { instanceOrParams = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var experimentsInstance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isConducted = !(instanceOrParams instanceof wix_experiments_1.default) && !!instanceOrParams.experiments;
                        experimentsInstance = ExperimentsService.buildInstance(instanceOrParams);
                        this.experimentsInstance = experimentsInstance;
                        return [4 /*yield*/, experimentsInstance.ready()];
                    case 1:
                        _a.sent();
                        // to cut off cases when multiple inits are called sequentially, to avoid setting "isConducted"
                        // while new instance is still loading the FTs
                        if (experimentsInstance === this.experimentsInstance) {
                            this.isConducted = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ExperimentsService.prototype.ready = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.experimentsInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.experimentsInstance.ready()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.init()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, this.experimentsInstance];
                }
            });
        });
    };
    ExperimentsService.prototype.reset = function () {
        this.experimentsInstance = null;
        this.isConducted = false;
    };
    return ExperimentsService;
}());
exports.ExperimentsService = ExperimentsService;
exports.experimentsService = new ExperimentsService();
//# sourceMappingURL=index.js.map